import type { Url } from 'next/dist/shared/lib/router/router';
import type { ReadonlyURLSearchParams } from 'next/navigation';
import type { NextRouter } from 'next/router';
import { attach, createEvent, createStore, sample } from 'effector';
import { reset, spread } from 'patronum';

export const setup = createEvent<{
  router: NextRouter | null;
  searchParams: ReadonlyURLSearchParams | null;
  pathname: string | null;
}>();
const setRouter = createEvent<NextRouter | null>();
const setSearchParams = createEvent<ReadonlyURLSearchParams | null>();
const setPathname = createEvent<string | null>();

export const $router = createStore<NextRouter | null>(null);
export const $searchParams = createStore<ReadonlyURLSearchParams | null>(null);
export const $pathname = createStore<string | null>(null);

export const sanitize = createEvent();

reset({ clock: sanitize, target: [$router, $searchParams, $pathname] });

sample({
  clock: setRouter,
  target: $router,
});

sample({
  clock: setSearchParams,
  target: $searchParams,
});

sample({
  clock: setPathname,
  target: $pathname,
});

sample({
  clock: setup,
  target: spread({
    targets: {
      router: setRouter,
      searchParams: setSearchParams,
      pathname: setPathname,
    },
  }),
});

export const navigateToFx = attach({
  source: { router: $router },
  effect: (
    { router },
    {
      url,
      options,
    }: {
      url: Url;
      options?: {
        shallow?: boolean;
        locale?: string | false;
        scroll?: boolean;
        unstable_skipClientCache?: boolean;
      };
    },
  ) => {
    if (!router) return;

    return router.push(url, undefined, options);
  },
});
